<template>
    <div>

        <el-form @submit.native.prevent="onSubmitSuporte" style="min-height: 130px;" v-loading="editSuporte && !dados.id" :model="dados" ref="dados" label-position="top">
            <div v-if="!editSuporte || dados.id">

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24" v-if="dados.instituicao">
                        <label style="padding: 0 0 5px 5px; line-height: 36px; color: #606266;">INSTITUIÇÃO</label>
                        <div class="style-input" style="background-color: #ebebeb !important;">
                            {{ dados.instituicao }}                            
                        </div>                            
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Seu Telefone" prop="telefone" :rules="[$requiredBlur]" key="telefone">
                            <el-input v-mask="'(##) #########'" v-model="dados.telefone" maxlength="191" v-on:blur="formatData('telefone', 14)"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>                 
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Texto" prop="texto" :rules="[$requiredBlur]" key="texto">
                            <el-input class="u-mt-10" placeholder="Atenção: Informe todos os dados relacionados a sua solicitação. Por exemplo: o nome do aluno, nome da instituição e qualquer informaçao relevante a sua solicitação." :rows="15" type="textarea" v-model="dados.texto"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item class="u-text-right u-mt-15">
                            <el-button type="primary" id="btn-suporte" native-type="submit">SALVAR</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
                
            </div>
        </el-form>

    </div>
</template>
<script>

export default {
    props: ['paramId'],
    data: () => ({
        editSuporte: false,
        alert: false,
        dados: {
            id: '',
            instituicao: '',
            telefone: '',
            texto: ''
        }

    }),
    mounted () {

        if(this.$store.state.config.instituicao && this.$store.state.config.instituicao.nome){

            this.dados.instituicao = this.$store.state.config.instituicao.nome;
        }

    },
    methods:{
        getSuporteById(id){

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/suporte/getById/` + id, this.$store.getters.getHeaderAuth).then(response => {

                this.dados = JSON.parse(JSON.stringify(response.data));
 
            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        onSubmitSuporte(){

            document.getElementById("btn-suporte").focus();

            this.$refs.dados.validate((valid) =>{ if(valid){
 
                window.eventBus.$emit('loading', true);                

                if(this.editSuporte){

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/suporte/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth).then(response => {

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        
                        this.$emit('onSubmitSuporte');

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }else{

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/suporte/store`, this.dados, this.$store.getters.getHeaderAuth).then(response => {
                    
                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});

                        this.$emit('onSubmitSuporte');

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        },
        resetFormSuporte(){
          
            this.dados = { id: '', nome: '', descricao: '', ativa: '', emDestaque: null, imagem: '' };
            this.$refs.dados.clearValidate();
        },
        formatData(field, size = null){

            //TRATA OS INPUTS - LETRA MAIÚCULA 
                        
            if(!this.dados[field])
                return false;

            if(size && this.dados[field].length < size)
                this.dados[field] = '';            

            this.dados[field] = this.dados[field].toUpperCase();

            this.dados[field] = this.$removerAcentos(this.dados[field]);
        }
    },
    watch: {
        paramId: {
            immediate: true,
            handler (value) {

                if(value){

                    this.getSuporteById(value);
                    this.editSuporte = true;
                } 
            }
        },
    }
}
</script>
